import React from "react"
// import chevron from './Chevron.svg'
import './Select.css'

const chevron = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDE0IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNyA3TDEzIDEiIHN0cm9rZT0iIzI1MjgyQiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=='

function useClickOutside(onClickOutside) {
    let ref = React.useRef(null)
    React.useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                onClickOutside()
            }
        }
        document.addEventListener("mousedown", handleClickOutside)
        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [ref])
    return ref
}

export const Select = ({ options, value, onChange, getValue, emptyValue, disabled, className }) => {
    let [isOpen, setOpen] = React.useState(false)
    let ref = useClickOutside(() => setOpen(false))

    React.useEffect(
        () => {
            if (disabled && isOpen) {
                setOpen(false)
            }
        }
    )

    let renderOption = (option, i) => {
        let handleClick = () => {
            onChange(option)
            setOpen(false)
        }

        let className = `${option === value ? 'select-value' : 'select-option'} padding-10`

        return (
            <div key={i} onClick={handleClick} className={className}>
                {option ? getValue(option) : emptyValue}
            </div>
        )
    }

    return (
        <div onClick={() => !disabled && setOpen(!isOpen)} className={`select ${className} ${disabled ? 'cursor-default' : ''}`}>
            <div className={`${value ? '' : 'select-option'}`}>
                {getValue(value) || emptyValue}
            </div>

            {isOpen && (
                <div ref={ref} className='select-options'>
                    {options?.map(renderOption)}
                </div>
            )}

            <img src={chevron} className={`select-chevron ${disabled ? 'select-disabled' : ''}`}/>
        </div>
    )
}